import { ReactComponent as Icon } from "../icons/bell.svg";

const Bell = ({color, wth, curs, clickFunc}) => {
  return (
    <div>
      <Icon style={({fill: color, width: wth, height: wth, marginTop: "5px", cursor: "pointer"})}/>
    </div>
  );
};

export default Bell;